import { useTranslation } from 'react-i18next';
import MenuItem from '@/components/conversations/conversation-menu-modal/menu-item';
import CollectionItem from '@/components/user/collection-item/collection-item';
import type { Collection } from '@/hooks/collections/use-collections';
import { useIsDesktop } from '@/hooks/use-user-platform';
import { ConversationMessageContentType } from '@/models/conversations/conversation';

interface Props {
  collection: Collection;
  onResolve: (resolution: string) => void;
  contextMenuType?: 'forward' | 'normal';
}

export default function CollectionMenu({ collection, onResolve, contextMenuType }: Props) {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const handleForwardCollection = async () => {
    onResolve('forward');
  };

  const handleDeleteCollection = async () => {
    onResolve('delete');
  };

  const handleCopyCollectionContent = () => {
    onResolve('copy');
  };

  const menu = (
    <div className='flex-col flex rounded-lg bg-neutral-0 p-2 shadow-xl z-20 '>
      {contextMenuType === 'forward' ? (
        <MenuItem
          label={t('conversation.forward.send')}
          onClick={handleForwardCollection}
        />
      ) : (
        <>
          <MenuItem
            label={t('conversation.forward.forward')}
            onClick={handleForwardCollection}
          />
          {collection.Type === ConversationMessageContentType.Text && (
            <MenuItem
              label={t('common.copy')}
              onClick={handleCopyCollectionContent}
            />
          )}
          <MenuItem
            label={t('conversation.delete.delete')}
            onClick={handleDeleteCollection}
          />
        </>
      )}
    </div>
  );

  return isDesktop ? (
    menu
  ) : (
    <div className='flex flex-1 flex-col items-start justify-center gap-2'>
      <CollectionItem collection={collection} />

      {menu}
    </div>
  );
}
